import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

interface SxProps {
  isUsageBased?: boolean;
  disabled?: boolean;
}

export const root: SxStyle = {};

export const icon: SxStyleFunc<SxProps> = ({ isUsageBased, disabled }) => ({
  marginInlineStart: 0.5,
});

export const disabledIcon: SxStyle = {
  color: (p) => p.palette.grey[300],
  marginInlineStart: 0.5,
};
